import React, { useContext } from 'react'
import SearchDesktop from './SearchDesktop'
import SearchMobile from './SearchMobile'
import { useMediaQuery } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import Spacer from '../../components/layout/Spacer'
import { useRouter } from 'next/router'
import CartButton from '../../components/header/CartButton'
import get from 'lodash/get'
import SessionContext from '../../contexts/SessionContext'

function Search() {
  const router = useRouter()
  const { session } = useContext(SessionContext)

  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'))
  const isLarge = useMediaQuery(theme.breakpoints.up('md'))
  let { storeSlug } = router.query

  return (
    <>
      {!isDesktop && (
        <>
          <SearchMobile />
        </>
      )}
      <Spacer />
      {isDesktop && (
        <>
          <SearchDesktop />{' '}
        </>
      )}
    </>
  )
}

export default Search